export default __webpack_public_path__ + "ba7a934abce1756e25434d6f64cbdf05.ttf";